export default "__VITE_ASSET__a79dc749__"